import {
  SET_VEHICLE_REQUEST,
  SET_VEHICLE_REQUEST_COUNT,
  SET_VEHICLE_REQUEST_LOADER,
  SET_VEHICLE_REQUEST_FILTERS,
  SET_VEHICLE_REQUEST_PAGINATION,
} from 'src/common/actions/constants';
import moment from 'moment';

const defaultRange = [moment().subtract(29, 'days'), moment()];
const defaultTimeFilters = [{
  columnName: 'created_at',
  fromDateString: defaultRange[0].format('YYYY-MM-DD'),
  toDateString: defaultRange[1].format('YYYY-MM-DD'),
}];
const defaultState = {
  loader: false,
  page_data: [],
  count: {},
  vehicleMakeIdList: [],
  planningHubIdList: [],
  hubLocationIdList: [],
  tripReferenceNumberList: [],
  filters: {
    timeFilters: defaultTimeFilters,
  },
  pagination: {
    pageNumber: 1,
    resultPerPage: 50,
    nextOrPrev: 'first',
  },
};

export default (state = defaultState, action) => {
  const { data } = action;
  switch (action.type) {
    case SET_VEHICLE_REQUEST_LOADER: {
      return {
        ...state,
        loader: data,
      };
    }
    case SET_VEHICLE_REQUEST: {
      return {
        ...state,
        ...data,
      };
    }

    case SET_VEHICLE_REQUEST_COUNT: {
      return {
        ...state,
        count: data,
      };
    }

    case SET_VEHICLE_REQUEST_FILTERS: {
      return {
        ...state,
        filters: data,
      };
    }

    case SET_VEHICLE_REQUEST_PAGINATION: {
      return {
        ...state,
        pagination: data,
      };
    }
    default:
      return state;
  }
};
